// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "th, td {\n  text-align: right;\n}\n\nth:first-child, td:first-child {\n  text-align: left;\n}\n", "",{"version":3,"sources":["databases-container.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","file":"databases-container.css","sourcesContent":["th, td {\n  text-align: right;\n}\n\nth:first-child, td:first-child {\n  text-align: left;\n}\n"]}]);
// Exports
module.exports = exports;
